














































import mixins from 'vue-typed-mixins'
import DiaryMixin from '../../DiaryMixin'

import Thought from './Thought.vue'

export default mixins(DiaryMixin).extend({
  components: { Thought },
})
